export enum localeNameSpaces {
  Apis,
  Components,
  ComplexComponents,
  Customer,
  Invoice,
  Ipg,
  Platform,
  Product,
  User,
  Utils,
  Report,
  Settlement,
  Wrapper,
}

export enum adminLocaleNameSpaces {
  Apis,
  Components,
  ComplexComponents,
  Dash,
  Gateway,
  Pardakhtyar,
  Pay,
  User,
  Utils,
  Verify,
  Withdraw,
  Settlement,
  Wrapper,
}
